document.querySelectorAll(".tiered-pricing__toggle").forEach((toggle) => {
  toggle.addEventListener("click", (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const controls = button.getAttribute("aria-controls");
    if (!controls) return;

    const panel = document.getElementById(controls);
    if (!panel) return;

    const isExpanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!isExpanded));
    panel.classList.toggle("is-open", !isExpanded);
  });
});

export {};
